import './App.css'
import ReactDatePicker from './ReactDatePicker'

function App() {
  return (
    <div className="app">
      <h2>Simple React Datepicker</h2>
      <ReactDatePicker />
      <p>👆 Click input to pick a date</p>
    </div>
  )
}

export default App
